


























import getCraftPages from '~/queries/craft-pages.gql'
import pageMixin from '@bkwld/cloak/mixins/page'
import { mergeShopifyProductCard } from 'library/helpers/products'
import colors from 'library/assets/vars/colors.json'
import Newsletter from '~/components/blocks/newsletter'

export default
	name: 'Collection'

	mixins: [ pageMixin ]

	components: { Newsletter }

	# Metadata
	head: -> @buildHead
		description: @page.marqueeDescription

	# Fetch page data
	asyncData: ({ app, params, payload }) ->

		# Get data
		[ page ] = payload || await app.$craft.getEntries
			query: getCraftPages
			variables:
				section: 'collections'
				uri: "collections/#{params.collection}"
		return app.$notFound() unless page

		# Get Shopify data for featured product cards, removing any cards that
		# couldn't be resolved.
		for card, idx in page.featuredCards || []
			try
				card.product = await mergeShopifyProductCard card.product?[0]
				throw "Product could not be merged" unless card.product
			catch e
				console.warn "Shopify product not found for featured card"
				delete page.featuredCards[idx]
		page.featuredCards = app.$nonEmpty page.featuredCards

		# Set data
		return { page }

	computed:

		# Blocks that are appended after the product filter
		appendedBlocks: ->
			if @page.swapMarqueeWithFirstBlock
			then @page.blocks.slice 1
			else @page.blocks

		# Simulate a simple marquee block payload
		simulatedMarqueeBlock: ->
			backgroundColor: @page.backgroundColor || colors.yellow
			balanceText: true
			breadcrumbAlign: 'center'
			breadcrumbs: [
				{
					text: 'Shop'
					href: '/collections/all'
				}
				{
					text: @page.title
					href: @$route.path
				}
			]
			copy: do =>
				copy = "<h1 class='style-h2'>#{@page.title}</h1>"
				copy += "<p>#{@page.marqueeDescription}</p>" if @page.marqueeDescription
				return copy

		newsletterData: -> @$store.state.globals.newsletter

		newsletterBlock: ->
			body: [
				"<h2 class='style-h2'>#{@newsletterData.title}</h2>" if @newsletterData.title
				"<p>#{@newsletterData.description}</p>" if @newsletterData.description
			].join ' '

